import React, {
  ChangeEvent,
  FunctionComponent,
  SetStateAction,
  SyntheticEvent,
  useEffect,
  useState,
} from "react";
import "../../ForgotPasswordContainer/styles.scss";
import "./styles.scss";
import Button from "../../common/Button";
import Label from "../../Label";
import "./PasswordInput.scss";
import PasswordInput from "../../PasswordInput";

type Props = {
  handleSubmit: (event: SyntheticEvent, code: {}, newPassword: string) => void;
  handleUpdateCode: (ix: string, e: any) => void;
  code: { [key: string]: string };
  password: string;
  setPassword: (password: string) => void;
  isLoading: boolean;
};

const CompleteRestoreForm: FunctionComponent<Props> = ({
  handleSubmit,
  handleUpdateCode,
  code,
  password,
  setPassword,
  isLoading,
}) => {
  const [validPassword, setValidPassword] = useState<boolean>(false);
  useEffect(() => {
    document.getElementById("code-0")?.focus();
    return () => {};
  }, []);

  useEffect(() => {
    setValidPassword(
      Object.values(/^(?=.*\d).{6,}$/.test(password)).every(
        (isValid) => isValid
      )
    );
  }, [password]);

  return (
    <form
      className="complete-password__form"
      onSubmit={(e) => handleSubmit(e, code, password)}
    >
      <div>
        <p className="form__email--text">Ingresar código de verificación</p>
        <div className="code">
          {Object.keys(code).map((key: string) => (
            <input
              className="code__input"
              key={`code-digit-${key}`}
              id={`code-${key}`}
              name={`code-digit-${key}`}
              onKeyDown={(e) => handleUpdateCode(key, e)}
              placeholder=""
              required
              type="number"
              value={code[key]}
              pattern="[0-9]"
            />
          ))}
        </div>
      </div>
      <div>
        <label htmlFor="email" className="form__email--text">
          Nueva contraseña
        </label>
        <PasswordInput
          handleChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
          validPassword={validPassword}
        />
      </div>
      <Button type="submit" isLoading={isLoading}>
        Guardar
      </Button>
      <p className="complete-password__form__text">
        Si tienes alguna duda, envíanos un correo electrónico a{" "}
        <a href="mailto:info@rtabak.com.ar" className="form__text__mail">
          info@rtabak.com.ar
        </a>
        . Nos pondremos en contacto a la brevedad.
      </p>
    </form>
  );
};

export { CompleteRestoreForm };
